export function first(arr, iterator) {
    return arr.filter(iterator)[0];
}

export function flattenByKeys(arr) {
    return arr.reduce(function(output, item) {
        Object.keys(item).forEach(function(key) {
            if (!output[key]) {
                output[key] = [];
            }
            if (-1 === output[key].indexOf(item[key])) {
                output[key].push(item[key]);
            }
        });
        return output;
    }, {});
}

export function contains(arr, value) {
    return -1 < (arr || []).indexOf(value);
}
